import { Box, CircularProgress, Paper, Typography } from '@mui/material'
import { MdAddCircle } from 'react-icons/md'
import dayjs from 'dayjs'

export const ListaEvolucao = ({
  lista,
  idAtivo,
  onSelecionar,
  onNovo,
  permiteNovo = true,
  loading,
}) => {
  return (
    <Box>
      {permiteNovo && (
        <Paper
          onClick={onNovo}
          sx={{
            p: 2,
            mb: 1,
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            gap: 1,
            border:
              idAtivo === null ? '2px solid #1976d2' : '1px solid #e0e0e0',
            bgcolor: idAtivo === null ? '#e3f2fd' : 'background.paper',
          }}
        >
          <MdAddCircle />
          <Typography variant="subtitle2">Nova Evolução</Typography>
        </Paper>
      )}

      {loading ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
          <CircularProgress size={24} />
        </Box>
      ) : (
        <Box sx={{ maxHeight: 500, overflowY: 'auto' }}>
          {lista?.map((item) => {
            const isAtivo = item?.[0] === idAtivo
            return (
              <Paper
                key={item?.[0]}
                onClick={() => onSelecionar(item?.[0])}
                sx={{
                  p: 2,
                  mb: 1,
                  cursor: 'pointer',
                  border: isAtivo ? '2px solid #1976d2' : '1px solid #e0e0e0',
                  bgcolor: isAtivo ? '#e3f2fd' : 'background.paper',
                }}
              >
                <Typography variant="subtitle2">
                  {dayjs(item?.[4]).format('DD/MM/YYYY HH:mm')}
                </Typography>
                <Typography variant="body2" color="primary">
                  {item?.[1]?.[1] || '---'}
                </Typography>
                <Typography variant="body2" noWrap color="textSecondary">
                  {item?.[5] || '(sem texto)'}
                </Typography>
              </Paper>
            )
          })}
        </Box>
      )}
    </Box>
  )
}

export default ListaEvolucao
